/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptFlight } from '../models/V3StackAdaptFlight';
import { V3StackAdaptUserMetadata } from '../models/V3StackAdaptUserMetadata';
import { HttpFile } from '../http/http';

/**
* A specific campaign group configuration in StackAdapt
*/
export class V3StackAdaptCampaignGroupConfig {
    /**
    * Campaign group ID
    */
    'id'?: string;
    /**
    * Advertiser ID
    */
    'advertiserId'?: string;
    /**
    * Campaign group name
    */
    'name'?: string;
    /**
    * Budget type for the campaign group
    */
    'budgetType'?: string;
    /**
    * Flights configuration
    */
    'flights'?: Array<V3StackAdaptFlight>;
    /**
    * Revenue type
    */
    'revenueType'?: string;
    /**
    * Revenue pricing
    */
    'revenuePricing'?: number;
    /**
    * User metadata for the campaign group
    */
    'userMetadata'?: Array<V3StackAdaptUserMetadata>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "advertiserId",
            "baseName": "advertiserId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "budgetType",
            "baseName": "budgetType",
            "type": "string",
            "format": ""
        },
        {
            "name": "flights",
            "baseName": "flights",
            "type": "Array<V3StackAdaptFlight>",
            "format": ""
        },
        {
            "name": "revenueType",
            "baseName": "revenueType",
            "type": "string",
            "format": ""
        },
        {
            "name": "revenuePricing",
            "baseName": "revenuePricing",
            "type": "number",
            "format": "double"
        },
        {
            "name": "userMetadata",
            "baseName": "userMetadata",
            "type": "Array<V3StackAdaptUserMetadata>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCampaignGroupConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

